import { memo } from 'react'
import withErrorComponentBoundary from '../../../hooks/withErrorComponentBoundary/withErrorComponentBoundary'
import ToSAcceptanceFormController from './ToSAcceptanceFormController'

export const ToSAcceptanceFormControllerWithFallback =
    withErrorComponentBoundary(
        'ToSAcceptanceFormController',
        ToSAcceptanceFormController
    )

export default memo(ToSAcceptanceFormControllerWithFallback)
